import { render, staticRenderFns } from "./live-clock.vue?vue&type=template&id=6e7d2c83&scoped=true&"
import script from "./live-clock.js?vue&type=script&lang=js&"
export * from "./live-clock.js?vue&type=script&lang=js&"
import style0 from "./live-clock.scss?vue&type=style&index=0&id=6e7d2c83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7d2c83",
  null
  
)

export default component.exports